
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings/[listing_id]/statistics",
      function () {
        return require("private-next-pages/listings/[listing_id]/statistics.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listings/[listing_id]/statistics"])
      });
    }
  